import { makeBreakpoint } from '@utils/css';

const pageFadeDurationMs = 200;
const cardExitDurationMs = 250;
makeBreakpoint(0, 880);
makeBreakpoint(0, 1110);
const wrapper = "_275w1olebvn";
const header = "_275h1yidzst";
const headingHeart = "_275h123tb1y";
const link = "_275l1yhndd4";
const content = "_275c1dboel3";
const message = "_275m12a6xw4";
const list = "_275l1oddf7y";
const listItem = "_275l1selrfa";
const empty = "_275e1hl6w8x";

export { cardExitDurationMs, content, empty, header, headingHeart, link, list, listItem, message, pageFadeDurationMs, wrapper };
import "./molecule.favourites-section.style.linaria.module.css";
//# sourceMappingURL=molecule.favourites-section.style.js.map
